export default "__VITE_ASSET__sSB2AWF4__"